var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 36,
    viewBox: "0 0 60 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.784 17.8195C37.2333 17.6866 51.6945 17.1214 55.451 17.8195C75.6634 21.5429 23.3373 54.5209 0 21.2437C0.531904 19.382 27.1936 17.886 30.8172 17.8195H30.784Z",
    fill: "#AD775C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7831 5.65927e-05C40.0914 5.65927e-05 46.5075 2.12764 54.752 6.15017C2.19324 14.5941 -0.89842 -0.0331874 30.7831 5.65927e-05Z",
    fill: "#F8C1A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose1);
export default __webpack_public_path__ + "static/media/nose-1.60a13c216081eaaeeaf4fd058a41b386.svg";
export { ForwardRef as ReactComponent };